export default "__VITE_ASSET__a1e7ecc3__"